import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
import { useId } from "react";
/**
 * Can be sized by setting height only
 */
const SvgComponent = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => {
  // Dynamic mask id, sometimes required
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={undefined}
      height={18}
      fill="none"
      viewBox="0 0 18 18"
      aria-hidden="true"
      focusable="false"
      ref={ref}
      {...props}
    >
      <g clipPath={`url(#${id})`}>
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M9 0a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9Zm0 2c3.859 0 7 3.141 7 7s-3.141 7-7 7-7-3.141-7-7 3.141-7 7-7Zm-.104 9.95c.318 0 .579.097.783.291a.979.979 0 0 1 .306.74.97.97 0 0 1-.3.73c-.198.192-.462.29-.79.29-.326 0-.59-.098-.788-.29a.972.972 0 0 1-.3-.73.98.98 0 0 1 .307-.74c.203-.194.464-.29.782-.29ZM9.03 4c.95 0 1.686.23 2.21.69.525.46.787 1.108.787 1.946 0 .382-.085.741-.255 1.08-.171.34-.47.714-.895 1.126l-.544.52c-.34.326-.535.71-.585 1.15l-.026.41H8.002c0-.629.076-1.129.229-1.5.152-.374.43-.74.837-1.1.405-.362.675-.655.809-.882.135-.226.202-.466.202-.717 0-.758-.35-1.138-1.048-1.138-.332 0-.597.102-.797.307-.2.204-.303.486-.313.845H5.973c.009-.856.285-1.527.83-2.01C7.347 4.241 8.09 4 9.03 4Z"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id={id}>
          <path fill="currentColor" d="M0 0h18v18H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
const ForwardRef = forwardRef(SvgComponent);
const Memo = memo(ForwardRef);
export default Memo;
